var _path, _path2, _circle, _circle2, _circle3, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    width: 16,
    height: 16,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40,47H8a2,2,0,0,1-2-2V3A2,2,0,0,1,8,1H40a2,2,0,0,1,2,2V45A2,2,0,0,1,40,47ZM10,43H38V5H10Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15,19a2,2,0,0,1-1.41-3.41l4-4a2,2,0,0,1,2.31-.37l2.83,1.42,5-4.16A2,2,0,0,1,30.2,8.4l4,3a2,2,0,1,1-2.4,3.2l-2.73-2.05-4.79,4a2,2,0,0,1-2.17.25L19.4,15.43l-3,3A2,2,0,0,1,15,19Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 24,
    r: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 31,
    r: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 38,
    r: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33,26H22a2,2,0,0,1,0-4H33a2,2,0,0,1,0,4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33,33H22a2,2,0,0,1,0-4H33a2,2,0,0,1,0,4Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33,40H22a2,2,0,0,1,0-4H33a2,2,0,0,1,0,4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManage);
export default __webpack_public_path__ + "static/media/manage.371ce5c764d828f84605928be63a1a35.svg";
export { ForwardRef as ReactComponent };